var path = 'components/common/views/wrapper.html';
var html = "<ui-view ng-if=vm.loadBody() />";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;